export const getTabStockPromoOptions = (t) => [
  { type: 'stok', label: t('page.product_stock') },
  { type: 'promo', label: t('page.promotion') },
];
